const youtubeBackgroundModule = () => {
    const iframes = document.querySelectorAll('.js-youtube-background');

    if (!iframes.length) return;

    const REVEAL_DELAY_MS = 0;

    const revealIframe = (iframe) => {
        if (iframe.dataset.ytRevealed) return;

        iframe.dataset.ytRevealed = 'true';
        iframe.classList.remove('opacity-0');
        iframe.classList.add('opacity-100');
    };

    const initPlayers = () => {
        iframes.forEach((iframe) => {
            if (!iframe.id || iframe.dataset.ytReady) return;

            iframe.dataset.ytReady = 'true';

            new YT.Player(iframe.id, {
                events: {
                    onReady: (event) => {
                        event.target.mute();
                        event.target.unloadModule('captions');
                        event.target.playVideo();
                    },
                    onStateChange: (event) => {
                        if (event.data === YT.PlayerState.ENDED) {
                            event.target.seekTo(0);
                            event.target.playVideo();
                            return;
                        }

                        if (event.data === YT.PlayerState.PLAYING) {
                            event.target.unloadModule('captions');

                            // YouTube briefly shows centre transport controls on play —
                            // wait for them to dismiss before revealing the iframe.
                            window.setTimeout(() => revealIframe(iframe), REVEAL_DELAY_MS);
                        }
                    },
                },
            });
        });
    };

    if (window.YT?.Player) {
        initPlayers();
        return;
    }

    const previousReady = window.onYouTubeIframeAPIReady;

    window.onYouTubeIframeAPIReady = () => {
        if (typeof previousReady === 'function') previousReady();
        initPlayers();
    };

    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(tag);
    }
};

export default youtubeBackgroundModule;
